import maternidadeImg from "./lifehacks-images/maternidade.jpg"; 
import rules from "./lifehacks-images/rules.jpg"; 
import floripa from "./lifehacks-images/floripa.jpg"; 
import children from "./lifehacks-images/children.jpg"; 
import water from "./lifehacks-images/carol-magalhaes-IGcMTM5REAY-unsplash-fotor-20250413112947.png"; 

const articlesData = [
    {
      id: 1,
      title: "Правила въезда в Бразилию для россиян",
      picture: rules, 
      date: "06 апреля 2025",
      excerpt: "Узнайте, какие документы нужны для переезда",
      link: "/lifehacks/brazil-relocation",
    },
    {
      id: 2,
      title: "ТОП-5 лайфхаков для жизни в Флорианополисе",
      picture: floripa,
      date: "07 апреля 2025",
      excerpt: "Простые советы, которые сделают вашу жизнь на острове комфортнее.",
      link: "/lifehacks/florianopolis-lifehacks",
    },
    {
      id: 3,
      title: "Роддома во Флорианополисе",
      picture: maternidadeImg,
      date: "07 апреля 2025",
      excerpt: "Где рожать во Флорианополисе?",
      link: "/lifehacks/maternity-hospital",
    },
    {
      id: 4,
      title: "Оформление гражданства Бразилии для детей до 10 лет",
      picture: children,
      date: "09 апреля 2025",
      excerpt: "Ключевые моменты",
      link: "/lifehacks/for-child",
    },
        {
      id: 4,
      title: "Проверка качества воды на пляжах",
      picture: water,
      date: "14 мая 2025",
      excerpt: "Как использовать сайт IMA",
      link: "/lifehacks/water-quality",
    },
  ];
  
  export default articlesData;